import { useEffect } from 'react';
import 'htmx.org'; // 설치되어 있어야 함 (npm install htmx.org)

export default function HtmxModalLoader() {
  useEffect(() => {
    // htmx가 전역에 없는 경우 초기화
    if (!window.htmx) {
      require('htmx.org');
      alert("no");
    }
  }, []);

  return (
    <div>
      <button
        // data-hx-post-="https://riskmgmtweb.azurewebsites.net/table/filter/tb_cm_code/?code_type=asset_spec"
        data-hx-get="https://riskmgmtweb.azurewebsites.net/table/filter/tb_cm_code/?code_type=asset_spec"
        data-hx-target="#htmx-modal-content"
        data-hx-swap="innerHTML"
      >
        HTMX 모달 띄우기
      </button>

      {/* HTMX가 이 영역에 HTML 삽입 */}
      <div id="htmx-modal-content" className="htmx-modal" />
    </div>
  );
}